// extracted by mini-css-extract-plugin
export default {"share":"Share_share__rwLap","share__title":"Share_share__title__KFPXP","share__buttons":"Share_share__buttons__ceB4h"};